import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { once } from 'lodash-es'

export type BundleBaseItemProps = ModelProps<BundleBaseItem>

const BundleBaseItemLazyNone = once(() => new BundleBaseItem())

export class BundleBaseItem extends Model<BundleBaseItem> {
  @observable accessor inventoryItemId = Id.none
  @observable accessor inventoryItemVersionId = Id.none
  @observable accessor name = ''
  @observable accessor price = 0
  @observable accessor proPrice = 0
  @observable accessor description = ''
  @observable accessor workspaceId = Id.none
  @observable accessor archived = false

  static get none() {
    return BundleBaseItemLazyNone()
  }
}
